import {
  BaseReactiveValue1ggyqczzm31cy as BaseReactiveValue,
  BaseListenable1u3g4s45l82o6 as BaseListenable,
  BaseReactive302n39o7i5yop as BaseReactive,
} from './abstracts.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  set1y8eiqnqugbz3 as set,
  getValue6qi464mhg2s5 as getValue,
  setValue39oxnnnmdq4h2 as setValue,
  lens2e2i845xidu26 as lens,
  lens26es9640ifscs as lens_0,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
  get_state389x218zizu8a as get_state,
  beginUse146s8dwmfk72s as beginUse,
  ReactiveValue37mnzha3zo6xb as ReactiveValue,
  lens2x0usmj7eco4 as lens_1,
  lens2po2j99uxhjgr as lens_2,
  set1ugseoes1jrmg as set_0,
  ReactiveWithMutableValue1h1r6ig7acce5 as ReactiveWithMutableValue,
} from './coreInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { Default_getInstance3u4i6y54ri5cn as Default_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/random/Random.mjs';
import {
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance,
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
} from './ReactiveState.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SignalClass;
function Signal() {
  if (SignalClass === VOID) {
    class $ extends BaseReactiveValue() {
      static hak(startValue) {
        return this.xao(startValue);
      }
      qam(thisRef, property) {
        return this.pam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      sam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.ram(tmp, property, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
    }
    protoOf($).eak = valueSet;
    protoOf($).iah = set;
    protoOf($).pam = getValue;
    protoOf($).ram = setValue;
    protoOf($).vak = lens;
    protoOf($).dak = lens_0;
    initMetadataForClass($, 'Signal', VOID, VOID, [MutableReactiveValue(), BaseReactiveValue()], [1]);
    SignalClass = $;
  }
  return SignalClass;
}
function Constant$Companion$NOOP$lambda() {
  return Unit_instance;
}
function _Constant___init__impl__v45mub(value) {
  return value;
}
function _Constant___get_value__impl__gl47rj($this) {
  return $this;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        tmp.laq_1 = Constant$Companion$NOOP$lambda;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function Constant__addListener_impl_a5dmn8($this, listener) {
  return Companion_getInstance_0().laq_1;
}
function Constant__toString_impl_pfy7ct($this) {
  return 'Constant(value=' + toString($this) + ')';
}
function Constant__hashCode_impl_3osajy($this) {
  return $this == null ? 0 : hashCode($this);
}
function Constant__equals_impl_wsq65y($this, other) {
  if (!(other instanceof Constant()))
    return false;
  var tmp0_other_with_cast = other.maq_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var ConstantClass;
function Constant() {
  if (ConstantClass === VOID) {
    class $ {
      constructor(value) {
        Companion_getInstance_0();
        this.maq_1 = value;
      }
      f2() {
        return _Constant___get_value__impl__gl47rj(this.maq_1);
      }
      vah(listener) {
        return Constant__addListener_impl_a5dmn8(this.maq_1, listener);
      }
      toString() {
        return Constant__toString_impl_pfy7ct(this.maq_1);
      }
      hashCode() {
        return Constant__hashCode_impl_3osajy(this.maq_1);
      }
      equals(other) {
        return Constant__equals_impl_wsq65y(this.maq_1, other);
      }
    }
    protoOf($).sah = get_state;
    protoOf($).kaj = beginUse;
    initMetadataForClass($, 'Constant', VOID, VOID, [ReactiveValue()]);
    ConstantClass = $;
  }
  return ConstantClass;
}
var BasicListenableClass;
function BasicListenable() {
  if (BasicListenableClass === VOID) {
    class $ extends BaseListenable() {
      static paq() {
        var $this = this.uam();
        $this.oaq_1 = Default_getInstance().br(0, 100000);
        return $this;
      }
      toString() {
        return 'BasicListenable(' + this.oaq_1 + ')';
      }
      qaq() {
        super.mal();
      }
    }
    initMetadataForClass($, 'BasicListenable', $.paq);
    BasicListenableClass = $;
  }
  return BasicListenableClass;
}
var RawReactiveClass;
function RawReactive() {
  if (RawReactiveClass === VOID) {
    class $ extends BaseReactive() {
      static aai(start) {
        start = start === VOID ? Companion_getInstance().oah_1 : start;
        return this.ial(start);
      }
      rah(value) {
        super.rah(value);
      }
      sah() {
        return super.sah();
      }
    }
    initMetadataForClass($, 'RawReactive', $.aai);
    RawReactiveClass = $;
  }
  return RawReactiveClass;
}
var LateInitSignalClass;
function LateInitSignal() {
  if (LateInitSignalClass === VOID) {
    class $ extends BaseReactive() {
      static taq() {
        return this.ial();
      }
      eak(value) {
        this.rah(_ReactiveState___init__impl__fvdp9b(value));
      }
      uaq() {
        this.rah(Companion_getInstance().oah_1);
      }
    }
    protoOf($).vak = lens_1;
    protoOf($).dak = lens_2;
    protoOf($).iah = set_0;
    initMetadataForClass($, 'LateInitSignal', $.taq, VOID, [ReactiveWithMutableValue(), BaseReactive()], [1]);
    LateInitSignalClass = $;
  }
  return LateInitSignalClass;
}
//region block: exports
export {
  BasicListenable as BasicListenable3uz4a8xs34a0h,
  Constant as Constant3smypj7m9af27,
  LateInitSignal as LateInitSignal30crwrg540xyy,
  RawReactive as RawReactive253xb355brtjj,
  Signal as Signal1973xs1vkmdcb,
  _Constant___init__impl__v45mub as _Constant___init__impl__v45mub34czko7zopf6l,
  _Constant___get_value__impl__gl47rj as _Constant___get_value__impl__gl47rj3u5ywr3ls9g1y,
};
//endregion

//# sourceMappingURL=signals.mjs.map
